import React, { FC, ChangeEvent, ReactNode } from 'react';
import FormControlLabel, {
  FormControlLabelProps,
} from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import styled from 'styled-components';

const Label: FC<FormControlLabelProps> = styled(FormControlLabel)`
  margin-bottom: 0;
`;

interface CheckboxControlProps {
  label: ReactNode;
  helpText?: ReactNode;
  checked: boolean;
  disabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const CheckboxControl = ({
  label,
  helpText,
  checked,
  disabled = false,
  onChange,
}: CheckboxControlProps) => {
  return (
    <FormControl>
      <Label
        control={
          <Checkbox checked={checked} disabled={disabled} onChange={onChange} />
        }
        label={label}
      />
      {helpText !== undefined && <FormHelperText>{helpText}</FormHelperText>}
    </FormControl>
  );
};

export default CheckboxControl;
